export default __webpack_public_path__ + "static/media/banner-1.d5b3c9e3.png";